/**
 * URL slug for a species' pretty /species/:id/:slug link (and the species
 * segment of a single-species discussion's URL, see
 * addDiscussionSpeciesUrl.ts) - exactly Laravel's Str::slug(), which the
 * server builds every canonical URL and sitemap entry with (see
 * champis-species' SpeciesPageUrls): accents folded, then anything that
 * isn't a letter, digit, space or hyphen *dropped* rather than turned into
 * a hyphen ("s.l." -> "sl", not "s-l" - the difference that sent every
 * "s.l." species link to a non-canonical URL), then runs of spaces/hyphens
 * collapsed to one hyphen. Checked against Str::slug() on every species
 * name displayed on the site (8798, 2026-09-24): identical for all.
 * Purely cosmetic for routing: SpeciesPage.js only ever reads :id, so a
 * stale or missing slug still resolves to the right page (see the legacy
 * /species/:id route registered alongside the slugged one in extend.js) -
 * this never needs to be validated or redirected against, just generated.
 *
 * `canonicalName` can genuinely be missing, not just empty: Model.save()
 * optimistically pushes whatever was actually submitted into the local
 * model *before* the request completes (Model.ts's own pushData()), and
 * SpeciesAssignModal only ever submits {gbifId, cfId} pairs - no
 * canonicalName at all - so for the brief window between clicking
 * "Enregistrer" and the real, server-resolved response arriving,
 * SpeciesLabel (DiscussionHero/DiscussionListItem, wherever a discussion's
 * species renders) calls this with `undefined`. Confirmed the hard way:
 * `undefined.normalize(...)` threw, and since that happened mid-render,
 * the discussion's species display never got a chance to show the real,
 * corrected data once it *did* arrive a moment later - "add a species,
 * nothing updates" looked identical to a working saved discussion still
 * loading, but was in fact this exception breaking the redraw that should
 * have shown it.
 */
export default function speciesSlug(canonicalName) {
  return (canonicalName || '').normalize('NFD').replace(/\p{Mn}/gu, '').toLowerCase().replace(/_+/g, '-').replace(/@/g, '-at-').replace(/[^-\p{L}\p{N}\s]+/gu, '').replace(/[-\s]+/g, '-').replace(/^-+|-+$/g, '');
}
flarum.reg.add('champis-species', 'forum/utils/speciesSlug', speciesSlug);